import React from 'react';
import { MarkdownContent } from 'new/elements/MarkdownContent';
import InfoOutlineIcon from '@mui/icons-material/ErrorOutline';
import Tooltip, { DefaultTooltipPopperProps } from 'js/components/elements/mui/Tooltip';
import { TooltipProps } from '@mui/material/Tooltip/Tooltip';

import styles from './HeaderField.module.scss';

type Props = {
  className?: string;
  item: {
    description?: string;
    display_name: string;
  };
};

export function HeaderField({ item, ...rest }: Props) {
  if (!item.description)
    return (
      <span className={styles.label} {...rest}>
        {item.display_name}
      </span>
    );

  return (
    <Tooltip
      placement="top"
      rootStyle={{}}
      interactive="true"
      tooltipTheme="fieldInfo"
      PopperProps={DefaultTooltipPopperProps}
      title={<MarkdownContent>{item.description}</MarkdownContent>}
      children={
        <span className={styles.label} {...rest}>
          {item.display_name} {` `}
          <InfoOutlineIcon fontSize="small" />
        </span>
      }
    />
  );
}

type CustomTooltipWithChildrenProps = {
  description: string;
  children: React.ReactNode;
  tooltipProps?: TooltipProps & any;
  toolTipBackground?: 'fieldInfo' | 'light' | 'dark';
};

HeaderField.CustomTooltipWithChildren = (props: CustomTooltipWithChildrenProps) => {
  const { children, description, tooltipProps = {}, toolTipBackground = 'fieldInfo' } = props;

  return (
    <Tooltip
      interactive="true"
      placement="top"
      rootStyle={{}}
      tooltipTheme={toolTipBackground}
      PopperProps={DefaultTooltipPopperProps}
      {...tooltipProps}
      title={<MarkdownContent>{description}</MarkdownContent>}
      children={
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            width: 'fit-content',
          }}
        >
          {children}
          <InfoOutlineIcon fontSize="small" />
        </div>
      }
    />
  );
};
